module.exports = __webpack_public_path__ + "assets/ic_badge_06.1f914980.svg";